import { FC, Suspense } from "react";
import { ConfigProvider, Spin } from "antd";
import { useThemeStore } from "./stores/themeStore";
import { IntlProvider } from "react-intl";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRouter from "./routers/AppRouter";
import { GlobalLoading } from "./components";
import { HelmetProvider } from "react-helmet-async";

interface IProps {}

const App: FC<IProps> = () => {
  const { themConfig } = useThemeStore();
  const queryClient = new QueryClient();

  return (
    <HelmetProvider>
      <ConfigProvider theme={themConfig}>
        <QueryClientProvider client={queryClient}>
          <IntlProvider locale={"en"}>
            <Suspense fallback={null}>
              <Spin spinning={false} wrapperClassName="app-loading-wrapper">
                <AppRouter />
              </Spin>
            </Suspense>
            <GlobalLoading />
          </IntlProvider>
        </QueryClientProvider>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default App;
